export default __webpack_public_path__ + "static/media/finance4.23ac917e.mp4";